// extracted by css-extract-rspack-plugin
export default {"cls1":"SuggestionCard-cls1_H0l","cls2":"SuggestionCard-cls2_6FN SuggestionCard-cls1_H0l"};